export default "/images/about_banner.png?32cb841ca47b5781d3f69a9b333bce71";